module.exports = __webpack_public_path__ + "media/components/breakheader/background/background--10-f1fca5fbd02e47fae342cc3448d9bd8f.jpg";